module.exports = __webpack_public_path__ + "img/12-4.3125ab9b.png";